// extracted by mini-css-extract-plugin
export default {"formInputWrapper":"AdditionalInformation_formInputWrapper__Ww2a8"};